// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__SCr7W","active":"Nav_active__1Yxdg"};